import Utils from "../../../../../Utils.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/mms`;
    }
    /**
     * Creates and sends a new media message or multiple messages. Sending MMS
     * messages simultaneously to different recipients is limited up to 50
     * requests per minute; relevant for all client applications.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/mms
     * Rate Limit Group: Medium
     * App Permission: SMS
     * User Permission: OutboundSMS
     */
    async post(createMMSMessage, restRequestConfig) {
        const formData = await Utils.getFormData(createMMSMessage);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
